import LegacyHeader from './LegacyHeader';
import LegacyFooter from './LegacyFooter';
import { Outlet } from 'react-router';
import AnnouncementManager from '../Announcements/AnnouncementManager';

export const LegacyLayout = ({ userInfo, showCiscoArchive, announcementsArray, setAnnouncementsArray }) => {
    return (
        <>
            {announcementsArray?.length >= 1 &&
                <AnnouncementManager
                    announcementsArray={announcementsArray}
                    setAnnouncementsArray={setAnnouncementsArray}
                    language={userInfo.userLanguage}
                    userNtid={userInfo.userNTID}
                />
            }
            <div className="flex flex-col mx-auto header-container">
                <LegacyHeader userInfo={userInfo} showCiscoArchive={showCiscoArchive} />
            </div>
            <div className="main-container" id="main-container">
                <div className="flex flex-col mx-auto h-full">
                    <main className="flex-grow">
                        <Outlet />
                    </main>
                    <LegacyFooter />
                </div>
            </div>
        </>
    );
};
